import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from "@angular/core";
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash';
export class RuteadorModalResultadoAsignacionComponent {
    constructor(accesolocalstorage, rutService, clog, ruteadorService) {
        this.accesolocalstorage = accesolocalstorage;
        this.rutService = rutService;
        this.clog = clog;
        this.ruteadorService = ruteadorService;
        this.onAsignar = new EventEmitter();
        //Listado
        this.listadoResultadoAsignados = null;
        this.listadoResultadoAsignadosTotales = null;
        this.documentosAsignacion = [];
        this.beachesSeleccionados = [];
        this.sumCajas = 0;
        this.sumUnidad = 0;
        this.sumPeso = 0;
        this.sumVolumen = 0;
        this.sumMonto = 0;
        this.processing = false;
        this.log = this.clog.log('RESULTADO-ASIGNACION');
    }
    ngOnInit() {
    }
    loadAndShow(beachesSeleccionados, documentosAsignacion, unidad_negocio_codigo, fecha) {
        this.beachesSeleccionados = beachesSeleccionados;
        this.documentosAsignacion = documentosAsignacion;
        this.listadoResultadoAsignados = [];
        this.documentosAsignacion.forEach((element1) => {
            this.beachesSeleccionados.forEach((element2) => {
                if (element1.latitud.trim() === element2.latitud.trim()) {
                    if (element1.folio_recorrido_Detalle === 0) {
                        this.listadoResultadoAsignados.push({
                            folio: element1.folio,
                            tipo_dte_codigo: element1.tipo_dte_codigo,
                            fecha_emision: element1.fecha_emision,
                            vendedor_codigo: element1.vendedor_codigo,
                            vendedor: element1.vendedor,
                            rut_emisor: element1.rut_emisor,
                            ruta_codigo: element1.ruta_codigo,
                            cliente_proveedor_rut: element1.cliente_proveedor_rut,
                            nombre_cliente: element1.nombre_cliente,
                            comuna: element1.comuna,
                            total_monto: element1.total_monto,
                            caja: element1.caja,
                            unidad: element1.fraccion,
                            direccion_codigo: element1.direccion_codigo,
                            estado_cliente: element1.estado_cliente,
                            direccion_completa: element1.direccion_completa,
                            total_peso: element1.total_peso,
                            total_volumen: element1.total_volumen,
                        });
                    }
                }
            });
        });
        this.selectData(this.listadoResultadoAsignados);
        this.obtenerTotalesSeleccionPoligono(this.listadoResultadoAsignados);
        this.show();
    }
    obtenerTotalesSeleccionPoligono(listaDocumento) {
        this.listadoResultadoAsignadosTotales = [];
        this.listadoResultadoAsignadosTotales = _.cloneDeep(listaDocumento);
        this.listadoResultadoAsignadosTotales.forEach(mov => {
            delete mov.__typename;
            delete mov.estado;
            delete mov.estado_cliente;
            delete mov.nombre_cliente;
            delete mov.total_monto;
            delete mov.total_unidad;
            delete mov.total_cantidad;
            delete mov.total_volumen;
            delete mov.total_peso;
            delete mov.fecha_emision;
            delete mov.folio_recorrido_Detalle;
            delete mov.additionalInfo;
            delete mov.comuna_codigo;
            delete mov.vendedor_codigo;
            delete mov.territorio_codigo;
            mov.fraccion = mov.unidad;
            delete mov.unidad;
            delete mov.rutFormato;
        });
        const inputParams = {
            lista: this.listadoResultadoAsignadosTotales
        };
        this.ruteadorService.obtenerTotalesAsignacion(inputParams, ({ respuesta }) => {
            if (respuesta == null) {
                return;
            }
            let listaDocAsignadoTotalesSelect = respuesta;
            this.sumCajas = listaDocAsignadoTotalesSelect.total_cantidad;
            this.sumUnidad = listaDocAsignadoTotalesSelect.total_unidad;
            this.sumPeso = Math.round(_.sumBy(this.listadoResultadoAsignados, 'total_peso'));
            this.sumVolumen = _.sumBy(this.listadoResultadoAsignados, 'total_volumen');
            this.sumMonto = _.sumBy(this.listadoResultadoAsignados, 'total_monto');
            //this.log('Totales', JSON.stringify(this.resumen_totales))
        });
    }
    show() {
        //this.isEditing = false
        this.resultadoAsinacionModal.show();
    }
    hide() {
        this.resultadoAsinacionModal.hide();
    }
    selectData(documento) {
        this.listadoResultadoAsignados = documento;
        this.listadoResultadoAsignados.forEach((mov) => {
            mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
        });
    }
    asignar() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.processing = true;
            console.log("Asignar");
            this.onAsignar.emit();
            yield this.hide();
        });
    }
    clear() {
        this.processing = false;
    }
}
